<template>
    <sys-register-base
        :model.sync="modelBase"
        title="Assinar Espelho de Ponto"
        icon="mdi-signature-freehand"
        color="purple white--text"
        v-bind:show.sync="dialog"
        maxWidth="700"
        :actions="false"
    >
        <template v-slot:form>

            <v-alert v-if="error" type="error" dense outlined class="mb-4">
                {{ message }}
            </v-alert>

            <v-alert v-if="!error && infoMessage" type="info" dense outlined class="mb-4">
                {{ infoMessage }}
            </v-alert>

            <div v-if="loading" class="text-center py-12">
                <v-progress-circular indeterminate color="purple" size="48" />
                <p class="mt-4">Preparando documento para assinatura...</p>
            </div>

            <iframe
                v-else-if="embedUrl"
                :src="embedUrl"
                class="sign-embedded-frame"
                title="Assinatura do Espelho de Ponto"
                allow="geolocation; camera; microphone"
            ></iframe>

            <v-row v-if="embedUrl" class="mt-2" no-gutters>
                <v-col cols="12" class="text-right">
                    <v-btn text color="grey darken-1" @click="dialog = false">
                        Fechar
                    </v-btn>
                </v-col>
            </v-row>

        </template>
    </sys-register-base>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: "SysOccurrenceSignEmbeddedDialog",
    data: () => ({
        dialog: false,
        modelBase: {},
        loading: false,
        checkingStatus: false,
        embedUrl: null,
        error: false,
        message: '',
        infoMessage: '',
    }),
    props: {
        show: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => ({})
        }
    },
    beforeDestroy() {
        // Se a tela "Ponto Docente" for fechada por inteiro enquanto este modal ainda está
        // aberto, o v-if do componente pai destrói este componente diretamente, sem passar
        // pelo watcher de "show" abaixo. Garante que a lista seja atualizada mesmo assim.
        if (this.embedUrl) {
            this.checkStatus();
        }
    },
    watch: {
        dialog(dialog_new, dialog_old) {
            if (dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }
        },
        show(show_new) {
            this.dialog = show_new;

            if (show_new) {
                this.startSignature();
                return;
            }

            // Sempre verifica na B4 ao fechar (mesmo numa retomada): não dá para saber, de fora
            // do iframe (origem cruzada), se o professor concluiu a assinatura nesta sessão.
            if (this.embedUrl) {
                this.checkStatus();
            }

            this.embedUrl = null;
            this.infoMessage = '';
        },
    },
    methods: {
        ...mapActions('timeSheet', [
            'ActionOccurrenceSheetSignEmbedded',
            'ActionRefreshSignatureStatusOccurrenceSheet',
        ]),

        startSignature() {
            this.error = false;
            this.message = '';
            this.infoMessage = '';
            this.embedUrl = null;
            this.loading = true;

            this.ActionOccurrenceSheetSignEmbedded({ id: this.item.id })
                .then((res) => {
                    if (res.data.already_signed || res.data.already_refused) {
                        // O documento já estava assinado ou recusado na B4 (status local
                        // desatualizado): fecha o modal e atualiza a lista com o status correto.
                        this.$emit('onCompleted');
                        this.dialog = false;
                        return;
                    }

                    this.embedUrl = res.data.embed_url;
                })
                .catch((error) => {
                    this.error = true;
                    this.message = error.message || 'Erro ao preparar documento para assinatura';
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        checkStatus() {
            this.checkingStatus = true;
            this.error = false;
            this.infoMessage = '';

            this.ActionRefreshSignatureStatusOccurrenceSheet({ id: this.item.id })
                .then((res) => {
                    // Recarrega a lista para refletir o status atual (gerado ou assinado),
                    // sempre que o status é consultado - seja ao fechar o modal ou pelo botão abaixo.
                    this.$emit('onCompleted');

                    if (res.data && [3, 5].includes(res.data.occurrence_sheet_sign_status_id)) {
                        this.dialog = false;
                    } else {
                        this.infoMessage = 'Ainda não identificamos a assinatura. Conclua a assinatura na área acima e tente novamente.';
                    }
                })
                .catch((error) => {
                    this.error = true;
                    this.message = error.message || 'Erro ao consultar status da assinatura';
                })
                .finally(() => {
                    this.checkingStatus = false;
                });
        },
    }
}
</script>

<style scoped>
.sign-embedded-frame {
    width: 100%;
    height: 65vh;
    border: none;
}
</style>
